var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "field has-addons slug",
          class: { "is-error": _vm.showError },
        },
        [
          _c("p", { staticClass: "control" }, [
            _c("a", { staticClass: "button is-static" }, [
              _vm._v(" " + _vm._s(_vm.label) + " "),
            ]),
          ]),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              staticClass: "input",
              class: [{ "data-hj-whitelist": _vm.whitelist }],
              attrs: { type: "text", name: _vm.name, "data-test": _vm.name },
              domProps: { value: _vm.value },
              on: { input: _vm.input, blur: _vm.myBlur },
            }),
          ]),
        ]
      ),
      _vm.showError
        ? _c(
            "p",
            {
              staticClass: "help is-danger",
              attrs: { "data-test": "error-" + _vm.name },
            },
            [_vm._v(" " + _vm._s(_vm.error) + " ")]
          )
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }